import RenderRouter from '@/routes';
import { NavMenu } from '@shopify/app-bridge-react';
import { AppProvider } from '@shopify/polaris';
import de from '@shopify/polaris/locales/de.json';
import en from '@shopify/polaris/locales/en.json';
import es from '@shopify/polaris/locales/es.json';
import fr from '@shopify/polaris/locales/fr.json';
import it from '@shopify/polaris/locales/it.json';
import vi from '@shopify/polaris/locales/vi.json';
import hi from './translate/hindu.json';

import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './App.css';
import { config } from './config';
import { Embedded } from './constants/enum';
import { PATH } from './constants/path';
import userPlans from './hooks/userPlans';

interface NavigationProps {
  label: string;
  pathname: string;
  url: {
    pathname: string;
    search: string;
  };
}

const navigationList: NavigationProps[] = [
  {
    label: 'Store verification',
    pathname: PATH.POP_UP_CUSTOMIZATION.pathname,
    url: PATH.POP_UP_CUSTOMIZATION,
  },
  // {
  //   label: 'Checkout verification',
  //   pathname: PATH.CHECKOUT_VERIFICATION.pathname,
  //   url: PATH.CHECKOUT_VERIFICATION,
  // },
  {
    label: 'Translation',
    pathname: PATH.TRANSLATION.pathname,
    url: PATH.TRANSLATION,
  },
  {
    label: 'Terms and conditions',
    pathname: PATH.TERM_AND_CONDITION.pathname,
    url: PATH.TERM_AND_CONDITION,
  },
  {
    label: 'Settings',
    pathname: PATH.SETTINGS.pathname,
    url: PATH.SETTINGS,
  },
  {
    label: 'Pricing',
    pathname: PATH.PRICING_PLAN.pathname,
    url: PATH.PRICING_PLAN,
  },
];

function App() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { isUserLimited } = userPlans();

  const navigationLinks = isUserLimited
    ? navigationList
    : navigationList.filter((item) => item.pathname !== PATH.PRICING_PLAN.pathname);

  const languageJson = useMemo(() => {
    switch (i18n.language) {
      case 'it':
        return it;
      case 'de':
        return de;
      case 'es':
        return es;
      case 'fr':
        return fr;
      case 'vi':
        return vi;
      case 'hi':
        return hi;
      default:
        return en;
    }
  }, [i18n.language]);

  useEffect(() => {
    if (config && config.role !== 'admin') {
      const timer = setTimeout(() => {
        var crisp = document.createElement('script');
        crisp.setAttribute('src', `${process.env.REACT_APP_API_END_POINT}/file/crisp.js?shop=${config.shop}`);
        crisp.setAttribute('id', 'age-shopline-crisp');
        crisp.appendChild(document.createTextNode(``));
        document.body.appendChild(crisp);
      }, 2500);
      return () => {
        clearTimeout(timer);
      };
    }
  }, []);

  useEffect(() => {
    i18n
      .loadNamespaces(['common', 'dashboard', 'popup', 'setting', 'checkout', 'translation', 'term-condition'])
      .then(() => console.log('Language loaded'));
    // eslint-disable-next-line
  }, [i18n.language]);

  return (
    <AppProvider i18n={languageJson} i18nIsDynamicList>
      {config.embedded === Embedded.LIVE ? (
        <>
          <NavMenu>
            <a
              href={PATH.DEFAULT.pathname}
              rel="home"
              onClick={(e) => {
                e.preventDefault();
                navigate(PATH.DEFAULT);
              }}
            >
              Home
            </a>
            {navigationLinks.map((item) => {
              return (
                <a
                  id={item.pathname}
                  key={item.pathname}
                  href={item.pathname}
                  onClick={(event) => {
                    event.preventDefault();
                    navigate(item.url);
                  }}
                >
                  {item.label}
                </a>
              );
            })}
          </NavMenu>
          <RenderRouter />
        </>
      ) : (
        <RenderRouter />
      )}
    </AppProvider>
  );
}

export default App;
